import TaskType from '../Models/TaskType';
import DataGridRequest from './DataGridRequest';
export class DealLostReasonRequest extends DataGridRequest<TaskType> {
    Url = '/api/v1/settings/deal_lost_reasons';
}
